import { DIALOG_TOPICS_COLLAPSED } from "../../constants"

const DEFAULT_VALUE = false

export const getDialogTopicsCollapsed = (): boolean => {
    if (typeof window === "undefined") {
        return DEFAULT_VALUE
    }

    const storedData = sessionStorage.getItem(DIALOG_TOPICS_COLLAPSED)

    if (!storedData) {
        return DEFAULT_VALUE
    }

    try {
        return JSON.parse(storedData) as boolean
    } catch {
        return DEFAULT_VALUE
    }
}

export const saveDialogTopicsCollapsed = (value: boolean) => {
    sessionStorage.setItem(DIALOG_TOPICS_COLLAPSED, JSON.stringify(value))
}
